import React, { useState, useEffect } from 'react';

const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        if (onClose) onClose();
      }, 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const colors = {
    success: { bg: '#3FB984', icon: '✓' },
    error: { bg: '#F27D72', icon: '✕' },
    warning: { bg: '#E96A3A', icon: '⚠' },
    info: { bg: '#666A7A', icon: 'ℹ' },
  };

  const color = colors[type] || colors.success;

  return (
    <div
      style={{
        position: 'fixed',
        top: '24px',
        right: '24px',
        backgroundColor: '#FFFFFF',
        borderRadius: '12px',
        padding: '16px 24px',
        boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        gap: '12px',
        minWidth: '320px',
        maxWidth: '450px',
        zIndex: 10000,
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateX(0)' : 'translateX(100px)',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        border: `2px solid ${color.bg}`,
        direction: 'rtl'
      }}
    >
      <div
        style={{
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          backgroundColor: `${color.bg}20`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: color.bg,
          fontFamily: 'Cairo, sans-serif',
          fontSize: '18px',
          fontWeight: 700,
        }}
      >
        {color.icon}
      </div>
      <p
        style={{
          fontFamily: 'Cairo, sans-serif',
          fontSize: '14px',
          fontWeight: 600,
          color: '#2B2F3F',
          margin: 0,
          flex: 1,
          textAlign: 'right'
        }}
      >
        {message}
      </p>
      <button
        onClick={() => {
          setIsVisible(false);
          setTimeout(() => {
            if (onClose) onClose();
          }, 300);
        }}
        style={{
          border: 'none',
          background: 'transparent',
          color: '#666A7A',
          cursor: 'pointer',
          fontSize: '20px',
          padding: 0,
          width: '24px',
          height: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        ✕
      </button>
    </div>
  );
};

export default Toast;




